// @flow
import { FieldTextStateless as TextField } from '@atlaskit/field-text';
import React, { Component } from 'react';
import type { Dispatch } from 'redux';

import { Dialog } from '../../../base/dialog';
import { translate, translateToHTML } from '../../../base/i18n';
import { connect } from '../../../base/redux';
import { createBreakoutRoom, setNameBreakoutRoom } from '../../actions'


/**
 * The type of the React {@code Component} props of {@link RoomNameDialog}.
 */
type Props = {

    /**
     * The name of the conference room (without the domain part).
     */
     _breakoutRoomId: string,

    /**
     * Redux store dispatch method.
     */
    dispatch: Dispatch<any>,


    /**
     * Invoked to obtain translated strings.
     */
    t: Function
}
 
/**
 * Authentication message dialog for host confirmation.
 *
 * @returns {React$Element<any>}
 */
class RoomNameDialog extends Component<Props> {
    /**
     * Instantiates a new component.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props: Props) {
        super(props);
        this.state = {
            roomName:'',
            isError: false
        }

        this._onSubmit = this._onSubmit.bind(this);
        this._onRoomNameChange = this._onRoomNameChange.bind(this);

    }


    /**
     * Called when the cancel button is clicked.
     *
     * @private
     * @returns {void}
     */


    _onSubmit: () => void;

    /**
     * Called when the OK button is clicked.
     *
     * @private
     * @returns {void}
     */
    _onSubmit() {
        const { roomName } = this.state
        if (!roomName || !roomName.trim()) {
            this.setState({
                isError: true
            })
            return false;
        }
        const { dispatch, _breakoutRoomId } = this.props;

        this.setState({
            isError: false
        })
       // dispatch(createBreakoutRoom(roomName))
        dispatch(setNameBreakoutRoom(roomName, _breakoutRoomId))
        return true
    }

    _onRoomNameChange(event) {
        this.setState({
            roomName: event.target.value
        });
    }

    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     */
    render() {

        return (
            <Dialog
                isModal = { false }
                onSubmit = { this._onSubmit }
                titleKey = 'Enter Breakout Room Name'
                width = { 'small' }>
                <TextField
                    autoFocus = { true }
                    compact = { true }
                    label = 'roomname'
                    name = 'roomName'
                    onChange = { this._onRoomNameChange }
                    shouldFitContainer = { true }
                    type = 'text'
                    value = { this.state.roomName } />
                    {this.state.isError &&
                    <span className="error" style={{color:'red'}}>Please Enter Valid Name</span>
                    }
            </Dialog>
        );
    }
}

/**
 * Maps (parts of) the Redux state to the associated props for the
 * {@code RoomNameDialog} component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {Props}
 */
function mapStateToProps(state) {
    

    return {
        _room: ''
    };
}

export default translate(connect(mapStateToProps)(RoomNameDialog));
